export default "__VITE_ASSET__DID_4yAn__"